import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';
import { spotFinder } from './endpoints';

export const labourAddressApi = createApi({
  reducerPath: 'labourAddressApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['labourAddress'],
  endpoints: (builder) => ({
    findAllAddressDetail: builder.mutation({
      query(body) {
        return {
          url: spotFinder.addressDetailController.findAllAddressDetail,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),

    findAddressDetailById: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.addressDetailController.findAddressDetailById}${body.id}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),

    saveAddressDetail: builder.mutation({
      query(body) {
        return {
          url: body.payload.isEdit
            ? spotFinder.addressDetailController.updateAddressDetail
            : spotFinder.addressDetailController.saveAddressDetail,
          method: body.payload.isEdit ? 'PUT' : 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    updateAddressDetail: builder.mutation({
      query(body) {
        return {
          url: body.payload.isEdit
            ? spotFinder.addressDetailController.updateAddressDetail
            : spotFinder.addressDetailController.saveAddressDetail,
          method: body.payload.isEdit ? 'PUT' : 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    deleteAddressDetail: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.addressDetailController.deleteAddressDetail}${body.id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
  }),
});


export const {
  useFindAllAddressDetailMutation,
  useFindAddressDetailByIdMutation,
  useSaveAddressDetailMutation,
  useUpdateAddressDetailMutation,
  useDeleteAddressDetailMutation,
} = labourAddressApi;
